import {
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
  FormHelperText,
  FormControl,
  FormErrorMessage,
  Flex,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { Display03, Paragraph02 } from "~/components/Texts";
import OnboardingNavigation from "~/components/onboarding/OnboardingNavigation";
import { MdTitle } from "react-icons/md";
import { useTheme } from "@chakra-ui/react";
import { useState } from "react";
import { validateShopName } from "~/utils/InputValidators";
import { MIN_SHOP_NAME_LENGTH, MAX_SHOP_NAME_LENGTH } from "~/utils/Limits";

export default function OnboardingShopName({
  onboardingData,
  onBack,
  onComplete,
  showBack,
}) {
  const chakraTheme = useTheme();
  const [value, setValue] = useState(
    onboardingData.displayName ? onboardingData.displayName : ""
  );

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleComplete = () => {
    onComplete({ displayName: value, displayNameLanguageIso: "es" }, null);
  };

  const isStepReady = () => {
    return (
      value.length >= MIN_SHOP_NAME_LENGTH &&
      value.length <= MAX_SHOP_NAME_LENGTH
    );
  };

  return (
    <Flex flex="1" direction="column">
      <Box flex="1">
        <Stack
          height="100%"
          width={{ mobile: "100%", desktop: "80%" }}
          spacing="8"
        >
          <Display03>Nombre de tu tienda</Display03>
          <Paragraph02>
            El nombre de tu tienda es la identidad de tu marca ante tus
            clientes. Se utiliza en elementos de la interfaz de tu tienda online
            como así también en comunicaciones con tus clientes y colaboradores.
          </Paragraph02>
          <FormControl
            isInvalid={
              validateShopName(value) !== true &&
              value.length >= MIN_SHOP_NAME_LENGTH
            }
          >
            <InputGroup size="lg" width={{ mobile: "100%", desktop: "80%" }}>
              <InputLeftElement
                children={
                  <MdTitle
                    color={useColorModeValue(
                      chakraTheme.colors.light.brand.strong,
                      chakraTheme.colors.dark.brand.strong
                    )}
                  />
                }
              />
              <Input
                id="shop-name"
                value={value}
                onChange={(event) => handleChange(event)}
                type="text"
                placeholder="Nombre de tu tienda"
              />
            </InputGroup>
            <FormHelperText id="shop-name">
              Debe tener al menos {MIN_SHOP_NAME_LENGTH} carecteres.
            </FormHelperText>
            <FormErrorMessage>{validateShopName(value)}</FormErrorMessage>
          </FormControl>
        </Stack>
      </Box>
      <Box>
        <OnboardingNavigation
          showBack={showBack}
          readyToContinue={isStepReady()}
          onBack={() => onBack()}
          onNext={() => handleComplete()}
        />
      </Box>
    </Flex>
  );
}
